'use client'

import { useState, useEffect } from 'react'

export function useDomain() {
  const [city, setCity] = useState('Your City')
  const [domain, setDomain] = useState('YourCityOrthopedic.com')

  useEffect(() => {
    const hostname = window.location.hostname.replace(/^www\./i, '')
    const suffixMatch = hostname.match(/orthoped(?:ic|ics|ist)/i)
    const suffix = suffixMatch ? suffixMatch[0].toLowerCase() : 'orthopedic'
    const words = hostname.split(/orthoped(?:ic|ics|ist)/i)[0]
      .replace(/[.-]/g, ' ')
      .trim()
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')

    const cityName = words || 'Your City'
    setCity(cityName)
    setDomain(`${cityName.replace(/\s+/g, '')}${suffix.charAt(0).toUpperCase() + suffix.slice(1)}.com`)
  }, [])

  return { city, domain }
} 